import { useCallback, useState } from 'react';
import { influencer } from '@round/api';
import { ExplorePlatform } from '../components/CreatorExploreTable/helpers';

export function useCreatorExplorePlatformSelection() {
    const [selectedPlatforms, setSelectedPlatforms] = useState<Record<string, ExplorePlatform>>({});

    const getRowSelectedPlatform = useCallback(
        (row: influencer.CreatorSearchResult, fallback?: ExplorePlatform | undefined): ExplorePlatform => {
            // The first key in the response's platforms object denotes which platform satisfied API filters, so it should be selected by default
            const defaultPlatform = Object.keys(row.platforms ?? {})[0] as ExplorePlatform | undefined;
            const selectedPlatform = selectedPlatforms[row._id];
            const firstAvailablePlatform = Object.values(row.platforms).find(
                (platformsArray) => !!platformsArray.length
            );

            return selectedPlatform || fallback || defaultPlatform || firstAvailablePlatform;
        },
        [selectedPlatforms]
    );

    const onRowPlatformSelect = useCallback((creatorId: string, platform: ExplorePlatform) => {
        setSelectedPlatforms((prev) => ({ ...prev, [creatorId]: platform }));
    }, []);

    const resetSelectedPlatforms = useCallback(() => {
        setSelectedPlatforms({});
    }, []);

    return { getRowSelectedPlatform, onRowPlatformSelect, resetSelectedPlatforms };
}
